const logoMap: Record<string, string> = {
  // Lemonad
  "6221ca5a-f9ac-4831-b1e1-2b4cdda44179": "lemonadcard.png",

  // USDT (разные сети)
  "190d511e-717a-4930-896e-7e333e528f35": "usdt_bep20.png",
  "ebae185d-c954-43c1-ad24-cf8cf6a02c7c": "usdt_ethereum.png",
  "360f1e10-42db-40e3-b10e-adebd1f705a4": "usdt_ton.png",
  "a182d674-6dce-42cf-9e41-07174563ad33": "usdt_trc20.png",

  // Getuniq
  "9fddffbd-2ad0-4a03-835a-50fa222a16a3": "getuniq.png",
  "0d657926-4a71-4e9e-a459-f6773302d358": "getuniq.png",

  // Zaley Cash
  "bc95236a-73b0-41e9-ad6b-6f7b2e9533a5": "zaley.png",
  "7d09d184-cc2b-4819-b716-013f231726fe": "zaley.png",

  // Wire
  "708bbbf0-8151-4998-ada9-bd845c1a2472": "wire.png",
  "85205644-40c0-4bf2-84bd-51109d82c52e": "wire.png",
  "f4925ead-8d35-40e3-bcc3-bfe914cd7f06": "wire.png",

  // ИП
  "ab720af7-0ebd-454f-8d3c-ae40406877c3": "ipUsdt.png",
  "746d8648-bd3d-4b3d-a494-6b54873867b9": "ipRub.png",

  // Trust Wallet
  "531a1835-69f6-4b67-b7ee-526121462321": "trustwallet.png",
  "4881cd40-e938-40d7-9d55-6dbffb144b8f": "trustwallet.png",

  // Mybrocard
  "9a00e1ab-1c22-4015-bc2e-ca4406351295": "mybrocard.png",
  "f13a0d23-78f6-45ca-ada2-e62bb7019756": "mybrocard.png",

  // Capitalist
  "ac5d39d3-e743-4d46-872f-44fd5c179a7c": "default.png",
  "369e4a2c-6b87-305e-b452-304d9210cb2a": "default.png",

  // Adeerpay
  "a555c16d-34c7-48d6-9464-e1d7eeca6280": "adpos.png",

  // Karta.io/yes.card
  "cd9c9382-b717-47ec-94f6-1618fd59ca22": "karta.png",

  // Payoneer
  "7f9405f2-da68-400b-b6f0-f2e3a28bd73e": "payoneer.png",

  // Webmoney
  "4717ed83-db16-4d78-b1e5-ea5b8134341e": "default.png",
  "0868c338-27d1-4946-bd14-d915caa74c2f": "default.png",

  // Общие карты
  "75432b2d-d2be-4b29-b605-55dcd4f082e8": "card.png",
  "87668491-b87e-46b6-a60f-e1fdccfefa12": "card.png",

  // Наличные
  "eed57460-d746-4d02-b706-113ccb59f09e": "default.png",
  "d4fadfbd-4df5-40d2-a438-e916bb7f93c2": "default.png"
};

export function getLogoPath (id: string): string {
  return `/paymentSystems/${ logoMap[id] || "default.png" }`;
}
